import PatientDetails from "pages/patientDetails";
import Patients from "pages/patients";
import ClaimCodingOptimization from "pages/provider/claimCodingOpt";
import Eligibility from "pages/provider/eligibility";
import EncounterCoding from "pages/provider/encounterCoding";
import UsersList from "pages/users/usersList";

import Appointments from "pages/provider/Appointments";
import Dashboard from "pages/provider/Dashboard";
import AppointmentsSummary from "pages/provider/AppointmentsSummary";
import MemberSearch from "pages/provider/MemberSearch";
import Calendar from "pages/provider/Calendar";
import EncounterForm from "pages/provider/EncounterForm";
import Support from "pages/provider/Support";
import PatientProfile from "pages/provider/PatientProfile";
import VideoApp from "pages/provider/VideoApp";
import AllCETabs from "../components/UI/AllCETabs";
import MessageChat from "pages/provider/chat/MessageChat";
import PracticeList from "pages/users/practiceList";
import ActivitLogs from "pages/provider/activityLogs";

const providerRoutes = [
  {
    path: "/dashboard",
    isExact: true,
    component: Dashboard,
  },
  {
    path: "/users",
    isExact: false,
    component: UsersList,
  },
  {
    path: "/calendar",
    isExact: true,
    component: Calendar,
  },
  {
    path: "/appointments",
    isExact: false,
    component: Appointments,
  },
  {
    path: "/dictation-summary",
    isExact: false,
    component: PracticeList,
  },
  {
    path: "/eligibility",
    isExact: false,
    component: Eligibility,
  },
  {
    path: "/dashboard/practice-settings",
    isExact: true,
    component: AllCETabs,
  },
  {
    path: "/appointments-count",
    isExact: false,
    component: AppointmentsSummary,
  },
  {
    path: "/encounter-forms",
    isExact: false,
    component: EncounterForm,
  },
  {
    path: "/search",
    isExact: false,
    component: MemberSearch,
  },
  {
    path: "/patientMessage",
    isExact: false,
    component: MessageChat,
  },
  {
    path: "/support",
    isExact: false,
    component: Support,
  },
  {
    path: "/connect",
    isExact: false,
    component: VideoApp,
  },
  {
    path: "/activity-logs",
    isExact: false,
    component: ActivitLogs,
  },
  {
    path: "/patientProfile",
    isExact: false,
    component: PatientProfile,
  },
  {
    path: "/patients",
    isExact: false,
    component: Patients,
  },
  {
    path: "/claim-coding-optimization",
    isExact: false,
    component: ClaimCodingOptimization,
  },
  {
    path: "/encounter-coding",
    isExact: false,
    component: EncounterCoding,
  },
  {
    path: "/patients-details/:data",
    isExact: false,
    component: PatientDetails,
  },
];

export default providerRoutes;
